const skillsList = [
  'JavaScript',
  'React',
  'Node.js',
  'Python',
  'Java',
  'C#',
  'HTML',
  'CSS',
  'SQL',
  'MongoDB',
  'Front-end Development',
  'Git',
  'PHP',
  'Ruby',
  'UX',
  'UI',
  'Express',
  'REST APIs',
  'OOP',
  'Django',
  'Machine Learning',
  'Swift',
  'NoSQL',
  'Angular',
  'JSON',
  'Micrsoft Azure',
  'Backend Development',

  // Add more skills to the list as needed
];

export default skillsList;
